import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["source", "button"];
  static values = {
    defaultMessage: { type: String, default: "Copy" },
    actionMessage: { type: String, default: "Click to copy" },
    successMessage: { type: String, default: "Copied!" },
    errorMessage: { type: String, default: "Failed to copy" },
  };

  connect() {
    this.tooltip = tippy(this.buttonTarget, {
      content: this.actionMessageValue,
      trigger: "mouseenter",
      placement: "top",
    });
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.destroy();
    }
  }

  copy() {
    const text = this.sourceTarget.value;

    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.tooltip.setContent(this.successMessageValue);
        this.buttonTarget.textContent = this.successMessageValue;
        this.buttonTarget.classList.remove("button-default");
        this.buttonTarget.classList.add("button-secondary");

        setTimeout(() => {
          this.tooltip.setContent(this.actionMessageValue);
          this.buttonTarget.textContent = this.defaultMessageValue;
          this.buttonTarget.classList.remove("button-secondary");
          this.buttonTarget.classList.add("button-default");
        }, 1500);
      })
      .catch(() => {
        this.tooltip.setContent(this.errorMessageValue);
        this.buttonTarget.classList.remove("button-default");
        this.buttonTarget.classList.add("button-destructive");

        setTimeout(() => {
          this.tooltip.setContent(this.actionMessageValue);
          this.buttonTarget.classList.remove("button-success");
          this.buttonTarget.classList.add("button-default");
        }, 2000);
      });
  }
}
